module.exports = __webpack_public_path__ + "img/server05.470ceed9.jpg";